<template lang="pug">
  v-dialog(
    v-model="_value"
    :persistent="loading"
    v-bind="$attrs"
    )
    v-toolbar.secondary(dark)
      span.title EDITAR GIROS - {{customer.personName}}
    v-card.pa-3
      v-form(ref="form")
        span.red--text(v-if="saveCustomerError") Error: {{saveCustomerError}}
        v-autocomplete(
          label="Giros"
          multiple
          chips
          deletable-chips
          outline
          :items="coreBusinessList"
          item-value="id"
          item-text="core_business"
          v-model="selectedBusinessList"
          :rules="coreBusinessRules"
          :disabled="loading"
          )
        v-select(
          label="Giro Principal"
          :items="mainCoreBusinessOptions"
          item-value="id"
          item-text="core_business"
          outline
          :rules="mainCoreBusinessRules"
          v-model="mainCoreBusiness"
          :disabled="loading"
          )
        .d-flex.justify-center(v-if="requireAuth")
          div(
            style="width: 200px; max-width: 200px; min-width: 200px;"
            )       
            span.caption.red--text(v-if="authError") {{authError}}
            v-text-field(
              outline
              label="Código de Supervisor"
              type="password"
              mask="A###########"
              :rules="authRules"
              v-model="supervisorCode"
              :disabled="loading"
              )
      v-layout
        v-flex.xs6
          v-btn.success(
            block
            @click="submit"
            :disabled="loading"
            ) 
            span GUARDAR CAMBIOS
            v-icon(right) save
        v-flex.xs6
          v-btn.success(
            block
            outline
            @click="_value = false"
            :disabled="loading"
            ) 
            span CANCELAR
            v-icon(right) cancel
</template>

<script>
import SlCustomer from '@/models/Sale/SlCustomer'
import axios from 'axios'
import { cloneDeep } from 'lodash'

const authorizeSupervisor = (
    code,
    permission = '&permission=authorize%20ticket%20sale'
) => {
    let route =
        process.env.VUE_APP_API_ROUTE +
        '/bar_authorization?auth_code=' +
        code +
        permission
    return new Promise((resolve, reject) =>
        axios
            .get(route)
            .then(response => {
                if (response.data.is_authorized) {
                    resolve(response.data)
                } else {
                    reject('No Autorizado')
                }
            })
            .catch(() => {
                reject('Error Autorización')
            })
    )
}

const required = v => !!v || 'Campo Obligatorio'
const initialState = () => ({
    loading: false,
    saveCustomerError: null,
    selectedBusinessList: [],
    mainCoreBusiness: null,
    supervisorCode: '',
    authError: null,
    authRules: [
        required,
        v =>
            (v.length && v.length === 12) ||
            'Debe ingresar código de 12 caracteres',
    ],
    coreBusinessRules: [
        v => (v && !!v.length ? true : 'Debe seleccionar al menos un giro'),
    ],
    mainCoreBusinessRules: [required],
})

export default {
    name: 'core-business-modal',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        customer: {
            type: Object,
            required: true,
        },
        coreBusinessList: {
            type: Array,
            required: true,
        },
        requireAuth: {
            type: Boolean,
            default: false,
        },
    },
    data: () => initialState(),
    computed: {
        _value: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            },
        },
        customerCoreBusiness() {
            return this.customer.g_core_business_sii
        },
        customerMainCoreBusiness() {
            return this.customer.main_g_core_business_sii_id
        },
        mainCoreBusinessOptions() {
            return this.selectedBusinessList.map(id =>
                this.coreBusinessList.find(cb => cb.id === id)
            )
        },
    },
    methods: {
        submit() {
            this.authError = null
            this.saveCustomerError = null
            if (!this.$refs.form.validate()) return
            this.loading = true
            if (this.requireAuth)
                authorizeSupervisor(this.supervisorCode)
                    .then(r => {
                        if (r && r.is_authorized) this.saveCustomer()
                        else {
                            this.authError = 'No Autorizado'
                            this.loading = false
                        }
                    })
                    .catch(e => {
                        this.loading = false
                        this.authError =
                            e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.message
                                ? e.response.data.message
                                : e
                    })
            else this.saveCustomer()
        },
        saveCustomer() {
            let customer = cloneDeep(this.customer)
            if (customer.businessName && !customer.business_name)
                customer.business_name = customer.businessName
            if (customer.personName && !customer.alias_name)
                customer.alias_name = customer.personName
            if (customer.personName && !customer.alias_name)
                customer.alias_name = customer.personName
            let selectedBusinessList = cloneDeep(this.selectedBusinessList)
            customer.core_business = [
                this.mainCoreBusiness,
                ...selectedBusinessList.filter(
                    cb => cb !== this.mainCoreBusiness
                ),
            ]
            if (!customer.email_collection)
                customer.email_collection = 'clientefactura@agroplastic.cl'
            if (!customer.rut.includes('-')) {
                let rut = customer.rut
                let dv = rut.slice(-1)
                let body = rut.slice(0, -1)
                customer.rut = body + '-' + dv
            }
            new SlCustomer(customer)
                .save()
                .then(r => {
                    this.$emit('customer:edited', customer)
                })
                .catch(
                    e =>
                        (this.saveCustomerError =
                            e &&
                            e.response &&
                            e.response.data.errors &&
                            e.response.data.errors.rut
                                ? 'El rut del cliente no es válido. Contacte con departamento de TI.'
                                : e &&
                                  e.response &&
                                  e.response.data &&
                                  e.response.data.message
                                    ? e.response.data.message
                                    : e)
                )
                .finally(() => (this.loading = false))
        },
    },
    watch: {
        customerCoreBusiness: {
            immediate: true,
            handler(v) {
                this.selectedBusinessList = v.map(v => v.id)
            },
        },
        customerMainCoreBusiness: {
            immediate: true,
            handler(v) {
                this.mainCoreBusiness = v
            },
        },
        value(v) {
            if (!v) this.supervisorCode = ''
        },
    },
}
</script>
